import { Typography } from '@mui/material';

export const InstructionsSection = () => {
    return (
        <Typography variant="body2" sx={{ mb: 4, color: 'text.secondary' }}>
            Manage avatar ordering and grouping using drag and drop. Reorder avatars by dragging them. Click the group icon (👥) on any
            avatar to create a group, then drag other avatars into the group to add alternatives.
            <br />
            <br />
            The output includes both the ordering (
            <Typography
                component="a"
                href="https://app.launchdarkly.com/projects/default/flags/top_avatars/targeting?env=test&selected-env=test"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    color: 'primary.main',
                    textDecoration: 'underline',
                    '&:hover': { textDecoration: 'none' },
                }}>
                top_avatars
            </Typography>
            ) and grouping (
            <Typography
                component="a"
                href="https://app.launchdarkly.com/projects/default/flags/avatars_grouping/variations?env=test&selected-env=test"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    color: 'primary.main',
                    textDecoration: 'underline',
                    '&:hover': { textDecoration: 'none' },
                }}>
                avatars_grouping
            </Typography>
            ) configurations for LaunchDarkly.
        </Typography>
    );
};
